import { render, staticRenderFns } from "./application-credit.vue?vue&type=template&id=5dc50b86&"
import script from "./application-credit.vue?vue&type=script&lang=js&"
export * from "./application-credit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Baner: require('/var/www/components/baner/baner.vue').default,BenefitsSlider: require('/var/www/components/benefits/benefits-slider.vue').default,FormCredit2: require('/var/www/components/form/form-credit2.vue').default,FormCredit2Desktop: require('/var/www/components/form/form-credit2-desktop.vue').default})
